import React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { ActionPopoverProps, ITableAction } from "@command-center-app/index";

const ActionPopover: React.FC<ActionPopoverProps> = ({
  anchorEl,
  onClose,
  rowData,
  actions,
}) => {
  const open = Boolean(anchorEl);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minWidth: 150,
        }}
      >
        {actions.map((action: ITableAction) => (
          <Typography
            key={action.label}
            onClick={() => {
              action.actionCallback(rowData);
              onClose();
            }}
            sx={{
              fontFamily: "Inter",
              forntWeight: 400,
              fontSize: 14,
              padding: "8px 16px",
              cursor: "pointer",
              "&:hover": { backgroundColor: "rgba(53, 119, 212, 0.08)" },
            }}
          >
            {action.label}
          </Typography>
        ))}
      </Box>
    </Popover>
  );
};

export default ActionPopover;
